import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Collapse } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { createSx } from 'ui-lib/utils';
import Button from '../../../Button';
import HttpErrorItem from './components/HttpErrorItem';
import { hasVisibleErrors, HttpErrorDetail } from './utils';

interface Props {
  errors: HttpErrorDetail;
  /** Message rendered by the snackbar itself, matching error entries are skipped to avoid duplicated data */
  message?: string;
  testID?: string;
}

const sx = createSx({
  toggleButton: {
    px: 0,
    mt: 1
  }
});

const HttpErrorDetails = ({ errors, message, testID = 'http-error-details' }: Props) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  if (!hasVisibleErrors(errors, message)) return null;

  const handleToggleClick = () => setExpanded(prevExpanded => !prevExpanded);

  return (
    <Box data-test-id={testID}>
      <Button
        variant='text'
        size='small'
        sx={sx.toggleButton}
        startIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        onClick={handleToggleClick}
        testID={expanded ? `${testID}-show-less-button` : `${testID}-show-more-button`}
      >
        {expanded ? t('showLess') : t('showMore')}
      </Button>
      <Collapse in={expanded} unmountOnExit>
        <HttpErrorItem errors={errors} message={message} testID={`${testID}-content`} />
      </Collapse>
    </Box>
  );
};

export default HttpErrorDetails;
